<template>
  <div class="mt-16 bg-white bg-opacity-60 min-h-screen pb-20">
    <div class="flex items-center justify-start bg-beige-academy-300 w-full py-2
      text-white text-left">
      <div class="text-md md:text-lg w-full px-6 md:px-8 font-sans-serif flex">
        <router-link class="pr-1" to="/teacher-dashboard/classrooms">
          {{$t('classrooms.classrooms')}}
        </router-link>
        / <span class="pl-2"> Tiers </span>
      </div>
    </div>
    <div class="flex w-3/4 justify-center items-center mt-10 mx-auto relative text-black">
      <h1 class="text-2xl text-center justify-self-center self-center w-full uppercase">
        {{ $t('tiers.title') }}
      </h1>
      <button class="font-bold rounded-full mx-2 transform hover:scale-110
      font-sans-serif text-beige-academy-300 z-30 absolute right-0"
      @click="$modal.show('add-tier')">
        <plus-icon class="bg-white rounded-full w-8 " />
      </button>
    </div>

    <div class="flex flex-col mt-10 w-full md:w-5/6 mx-auto">
      <tier-row v-for="tier in tiers" :key="tier.id" :tier="tier" :editable="true"
        @edit="editTier($event)" @delete="deleteTier($event)" :number="tiers.indexOf(tier)+1" />
    </div>

    <modal resizable name="add-tier" height="auto" :scrollable="true" :adaptive="true"
      :clickToClose="false">
      <new-tier @tierAdded="getTiers" />
    </modal>

    <modal resizable name="edit-tier" height="auto" :adaptive="true" :scrollable="true"
      :clickToClose="false">
      <edit-tier @tierEdited="getTiers" :givenTier="tierToEdit" />
    </modal>

    <modal resizable name="sure-to-delete" height="auto" :adaptive="true">
      <are-you-sure-to-delete
        @delete="sureDeleteTier"
        @close="$modal.hide('sure-to-delete')"
        v-if="tierToDelete"
        :question="$t('tier.delete')+tierToDelete.name+'?'"
        :isLoading="isLoading" />
    </modal>
  </div>
</template>

<script>
import NewTier from '@/components/modals/NewTier.vue';
import PlusIcon from '@/components/graphics/PlusIcon.vue';
import { mapGetters } from 'vuex';
import { getTeacherTiers } from '@/services/TeacherService';
import TierRow from '@/components/teachers/TierRow.vue';
import axios from 'axios';
import EditTier from '../components/modals/EditTier.vue';
import AreYouSureToDelete from '../components/modals/AreYouSureToDelete.vue';

export default {
  components: {
    NewTier,
    PlusIcon,
    TierRow,
    EditTier,
    AreYouSureToDelete,
  },

  data() {
    return {
      tiers: [],

      tierToEdit: null,
      tierToDelete: null,

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getTiers();
  },

  methods: {
    getTiers() {
      getTeacherTiers(this.user.slug).then(({ data }) => {
        this.tiers = [];
        this.tiers = data;
      });
    },

    editTier(tier) {
      this.tierToEdit = tier;
      this.$modal.show('edit-tier');
    },

    deleteTier(tier) {
      this.tierToDelete = tier;
      this.$modal.show('sure-to-delete');
    },

    sureDeleteTier() {
      this.isLoading = true;
      axios.delete(`/api/tiers/${this.tierToDelete.id}`).then(() => {
        this.isLoading = false;
        this.$modal.hide('sure-to-delete');
        this.getTiers();
      });
    },
  },
};
</script>
